import firebase from 'firebase'


const firebaseConfig = {
  apiKey: "AIzaSyDFg2sEeMdT6KGjmoHox7l1vf2mgazuBFs",
  authDomain: "drive-clone-e6526.firebaseapp.com",
  projectId: "drive-clone-e6526",
  storageBucket: "drive-clone-e6526.appspot.com",
  messagingSenderId: "800671624915",
  appId: "1:800671624915:web:89703786584f6b9b73ae26"
  };


  const firebaseApp = firebase.initializeApp(firebaseConfig);

  const auth = firebase.auth()
  const provider = new firebase.auth.GoogleAuthProvider()
  const storage = firebase.storage()
  const db = firebase.firestore()


  export { auth , provider , storage ,db}